import Vue from "vue";
import VueRouter from "vue-router";
import detectDevice from "../utils/detectDevice";
Vue.use(VueRouter);

const isMobile = detectDevice();
console.log("是否移动设备" + isMobile);

const routes = [
  //  {
  //     path: "/web",
  //     name: "web",
  //     redirect: "web",
  //     component: () => import("../views/Layout/index.vue"),
  //     children: [
  //         {
  //             path: "meoo",
  //             name: "meoo",
  //             meta: { title: 'Meoo Live' },
  //             component: () => import("../web/meoo.vue")
  //         },
  //     ]
  // }
  {
    path: "/",
    name: "web",
    meta: { title: "Meoo Live" },
    component: () =>
      isMobile ? import("../web/meooMobile.vue") : import("../web/meooPc.vue"),
  },
];

const router = new VueRouter({
  routes,
});

// 监听路由错误：捕获 ChunkLoadError（旧缓存请求已不存在的 chunk），自动刷新页面
router.onError((error) => {
  const pattern = /Loading chunk .* failed/i;
  const isChunkLoadFailed = pattern.test(error.message);
  if (isChunkLoadFailed) {
    // 避免无限刷新
    if (!sessionStorage.getItem("chunk-reload")) {
      sessionStorage.setItem("chunk-reload", "1");
      window.location.reload();
    }
  }
});

export default router;
